import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, ButtonProps } from '@mui/material';

// Public Cal.com booking page; it shows only the business name. The privacy notice says
// Cal.com handles bookings, so keep the two in sync if this changes.
export const bookingUrl = 'https://cal.com/scaledtech/intro';

function BookCallLink({ variant = 'outlined', sx }: Pick<ButtonProps, 'variant' | 'sx'>) {
  return (
    <Button
      href={bookingUrl}
      target='_blank'
      rel='noopener noreferrer'
      data-track='book_call'
      variant={variant}
      endIcon={<OpenInNewIcon aria-hidden='true' />}
      aria-label='Book a 20-minute call (opens Cal.com in a new tab)'
      sx={sx}
    >
      Book a 20-minute call
    </Button>
  );
}

export default BookCallLink;
